import { Paper, Typography } from "@mui/material";

export default function StatCard({ value, label }) {
  return (
    <Paper
      variant="outlined"
      sx={{
        textAlign: "center",
        borderRadius: 2,
        p: 1.75,
        bgcolor: "background.paper",
      }}
    >
      <Typography variant="h6" fontWeight={900}>
        {value}
      </Typography>
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>
    </Paper>
  );
}
